<unity-container>
  <h4>List of Services</h4>
  <!-- <div *ngIf="loading">
    <app-loader></app-loader>
  </div> -->

  <!-- Service Cards-->
  <unity-card-list>
    <li
      unity-card-list-item
      *ngFor="let service of storeService.services$ | async"
    >
      <app-service-card [service]="service"></app-service-card>
    </li>
  </unity-card-list>
</unity-container>
